export function getBaseUrl({ prodUrl = false }: { prodUrl?: boolean } = {}) {
  if (prodUrl) return "https://1dollar.fly.dev";
  if (process.env.PLAYWRIGHT) return "http://localhost:4322";
  if (process.env.BASE_URL) return process.env.BASE_URL;
  return prodUrl ? "https://1dollar.fly.dev" : "http://localhost:4321";
}
export function getPriceId(dev: boolean) {
  return dev
    ? "price_1QpUnvFhWVE5hfXAcxYfkZog"
    : "price_1Q2345678901234567890123";
}

/**
 * Default routing prompt for alert processing
 */
export const DEFAULT_ROUTING_PROMPT = `You are a routing system that determines which on-call rotation should handle an alert.
Consider the alert's title, description, source, and any relevant information in the payload.
Choose the most appropriate rotation based on the alert content and rotation names.`;

export const verbose = false;
